export default {
  paged: {
    select: 'id,isActive,sourceType,billingMode',
    searchSelect: ['customerCompany/commercialName'],
    orderBy: 'customerCompany/commercialName asc',
    expand: {
      customerCompany: {
        select: 'commercialName',
      },
    },
  },
  itemDetail: {
    expand: {
      customerCompany: {
        select: 'commercialName',
      },
    },
  },
};
